// extracted by mini-css-extract-plugin
module.exports = {"label":"ProxyBidLabel_label__rl38a","errorMessage":"ProxyBidLabel_errorMessage__tGJNo"};